import { menuBuilder } from 'services/Routes.service';

const OverallMenu = menuBuilder([]).addSubmenu();

export default OverallMenu;
